<section
	[editableInStoryblok]="_editable()"
	data-test-class="items-slider-section"
>
	<div class="section-spacing">
		<div class="section-inner section-gap">
			@let heading = title()[0];
			@if (heading) {
				<sb-heading-group-section
					[alignment]="headingAlignment()"
					[content]="heading.content"
					[headingType]="heading.headingType"
					[overline]="heading.overline"
					[title]="heading.title"
				/>
			}
			@if (itemSliderItems().length > 0) {
				<div class="max-md:-mx-3">
					<vp-slider
						[config]="config()"
						[itemTemplate]="itemTpl"
						[items]="itemSliderItems()"
						[label]="sliderLabel()"
						[trackFn]="trackByUrl"
						[uid]="_uid()"
					/>
					<ng-template #itemTpl let-item>
						<vp-slide [item]="item" />
					</ng-template>
				</div>
			}
		</div>
	</div>
</section>
